import { render, staticRenderFns } from "./collegeChange.vue?vue&type=template&id=686e1981&scoped=true&"
import script from "./collegeChange.vue?vue&type=script&lang=js&"
export * from "./collegeChange.vue?vue&type=script&lang=js&"
import style0 from "./collegeChange.vue?vue&type=style&index=0&id=686e1981&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686e1981",
  null
  
)

export default component.exports